import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ActiveConfirmation = ({
    showModal,
    hideModal,
    confirmModal,
    id,
    buttonText,
    displayText,
    message,
}) => {
    return (
        <Modal show={showModal} onHide={hideModal} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{displayText} Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-danger">{message}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="default" onClick={hideModal}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => confirmModal(id)}>
                    {buttonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ActiveConfirmation;
